import React, { Component } from 'react';
import FcmTokenService from '../../commons/firebase/FcmTokenService.js';

function getApiBase() {
    try {
        return (JSON.parse(localStorage.getItem('config')) || {}).apiUrlBase || '';
    } catch (e) {
        return '';
    }
}

function apiFetch(path, options) {
    return fetch(getApiBase() + path, Object.assign({
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization-Token': localStorage.getItem('token') || '',
        },
    }, options || {}));
}

function formatFechaHora(fechaHora) {
    if (!fechaHora) return '';
    var d = new Date(fechaHora.replace(' ', 'T'));
    var ahora = new Date();
    var diffMs = ahora - d;
    var diffMin = Math.floor(diffMs / 60000);
    if (diffMin < 1) return 'Ahora';
    if (diffMin < 60) return 'Hace ' + diffMin + ' min';
    var diffHs = Math.floor(diffMin / 60);
    if (diffHs < 24) return 'Hace ' + diffHs + ' hs';
    var diffDias = Math.floor(diffHs / 24);
    return 'Hace ' + diffDias + ' día' + (diffDias > 1 ? 's' : '');
}

var POLL_INTERVAL_MS = 300000; // fallback: 5 minutos (real-time via Firebase cuando hay permiso push)

class NotificationBell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            unreadCount: 0,
            notifications: [],
            loading: false,
        };
        this.wrapperRef = React.createRef();
        this.pollingInterval = null;
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.togglePanel = this.togglePanel.bind(this);
        this.markAllAsRead = this.markAllAsRead.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fetchCount();
        this.pollingInterval = setInterval(function() {
            this.fetchCount();
        }.bind(this), POLL_INTERVAL_MS);

        this.handleNuevaNotificacion = function() {
            this.fetchCount();
        }.bind(this);
        window.addEventListener('nueva-notificacion', this.handleNuevaNotificacion);

        this.handleSwMessage = function(event) {
            if (event.data && event.data.type === 'NUEVA_NOTIFICACION') {
                this.fetchCount();
            }
        }.bind(this);
        if (navigator.serviceWorker) {
            navigator.serviceWorker.addEventListener('message', this.handleSwMessage);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }
        window.removeEventListener('nueva-notificacion', this.handleNuevaNotificacion);
        if (navigator.serviceWorker) {
            navigator.serviceWorker.removeEventListener('message', this.handleSwMessage);
        }
    }

    fetchCount() {
        apiFetch('/notificaciones/no-leidas/count')
            .then(function(r) { return r.json(); })
            .then(function(data) {
                if (data && typeof data.count === 'number') {
                    this.setState({ unreadCount: data.count });
                }
            }.bind(this))
            .catch(function() {});
    }

    fetchNotifications() {
        this.setState({ loading: true });
        apiFetch('/notificaciones')
            .then(function(r) { return r.json(); })
            .then(function(data) {
                this.setState({
                    notifications: (data && data.data) ? data.data : [],
                    loading: false,
                });
            }.bind(this))
            .catch(function() {
                this.setState({ loading: false });
            }.bind(this));
    }

    handleClickOutside(event) {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ open: false });
        }
    }

    togglePanel() {
        FcmTokenService.solicitarPermisoPush();
        var opening = !this.state.open;
        this.setState({ open: opening });
        if (opening) {
            this.fetchNotifications();
        }
    }

    markAsRead(id, e) {
        if (e) e.stopPropagation();
        apiFetch('/notificaciones/' + id + '/leer', { method: 'PATCH' })
            .then(function() {
                this.setState(function(prevState) {
                    return {
                        notifications: prevState.notifications.filter(function(n) { return n.id !== id; }),
                        unreadCount: Math.max(0, prevState.unreadCount - 1),
                    };
                });
            }.bind(this))
            .catch(function() {});
    }

    markAllAsRead() {
        apiFetch('/notificaciones/leer-todas', { method: 'PATCH' })
            .then(function() {
                this.setState({ notifications: [], unreadCount: 0, open: false });
            }.bind(this))
            .catch(function() {});
    }

    handleNotificationClick(notification) {
        this.markAsRead(notification.id);
        window.location.href = notification.url;
    }

    render() {
        var open = this.state.open;
        var unreadCount = this.state.unreadCount;
        var notifications = this.state.notifications;
        var loading = this.state.loading;
        var self = this;

        return (
            <li
                className="nav-item"
                ref={this.wrapperRef}
                style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
            >
                {/* Bell button */}
                <a
                    className="nav-link"
                    style={{ cursor: 'pointer', padding: '0.5rem 0.8rem', position: 'relative', display: 'flex', alignItems: 'center' }}
                    onClick={this.togglePanel}
                >
                    <i className="ft-bell" style={{ fontSize: '1.25rem' }}></i>
                    {unreadCount > 0 && (
                        <span style={{
                            position: 'absolute',
                            top: '4px',
                            right: '2px',
                            background: '#FF5B5B',
                            color: 'white',
                            borderRadius: '10px',
                            minWidth: '18px',
                            height: '18px',
                            fontSize: '10px',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 4px',
                            lineHeight: '1',
                            boxSizing: 'border-box',
                        }}>
                            {unreadCount > 99 ? '99+' : unreadCount}
                        </span>
                    )}
                </a>

                {/* Dropdown panel */}
                {open && (
                    <div style={{
                        position: 'absolute',
                        top: 'calc(100% + 6px)',
                        right: 0,
                        width: '360px',
                        background: '#fff',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.13)',
                        borderRadius: '8px',
                        zIndex: 1050,
                        overflow: 'hidden',
                        border: '1px solid #e8e8e8',
                    }}>
                        {/* Panel header */}
                        <div style={{
                            padding: '12px 16px',
                            borderBottom: '1px solid #f0f0f0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            background: '#fafafa',
                        }}>
                            <span style={{ fontWeight: '600', fontSize: '14px', color: '#333' }}>
                                Notificaciones
                                {unreadCount > 0 && (
                                    <span style={{
                                        marginLeft: '8px',
                                        background: '#FF5B5B',
                                        color: 'white',
                                        borderRadius: '10px',
                                        padding: '1px 7px',
                                        fontSize: '11px',
                                        fontWeight: '700',
                                    }}>
                                        {unreadCount}
                                    </span>
                                )}
                            </span>
                            {notifications.length > 0 && (
                                <a
                                    style={{ fontSize: '12px', color: '#6e6cf6', cursor: 'pointer' }}
                                    onClick={this.markAllAsRead}
                                >
                                    Marcar todas como leídas
                                </a>
                            )}
                        </div>

                        {/* List */}
                        <div style={{ maxHeight: '380px', overflowY: 'auto' }}>
                            {loading ? (
                                <div style={{ padding: '40px 16px', textAlign: 'center', color: '#aaa' }}>
                                    <span style={{ fontSize: '13px' }}>Cargando...</span>
                                </div>
                            ) : notifications.length === 0 ? (
                                <div style={{ padding: '40px 16px', textAlign: 'center', color: '#aaa' }}>
                                    <i className="ft-bell-off" style={{ fontSize: '2rem', display: 'block', marginBottom: '10px', opacity: 0.5 }}></i>
                                    <span style={{ fontSize: '13px' }}>Sin notificaciones pendientes</span>
                                </div>
                            ) : (
                                notifications.map(function(n) {
                                    return (
                                        <div
                                            key={n.id}
                                            style={{
                                                padding: '12px 16px',
                                                borderBottom: '1px solid #f5f5f5',
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '12px',
                                                cursor: 'pointer',
                                                background: '#fafbff',
                                            }}
                                            onMouseEnter={function(e) { e.currentTarget.style.background = '#f0f0ff'; }}
                                            onMouseLeave={function(e) { e.currentTarget.style.background = '#fafbff'; }}
                                            onClick={function() { self.handleNotificationClick(n); }}
                                        >
                                            <div style={{
                                                width: '36px',
                                                height: '36px',
                                                borderRadius: '50%',
                                                background: '#ededfd',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                            }}>
                                                <i className="ft-message-square" style={{ fontSize: '15px', color: '#6e6cf6' }}></i>
                                            </div>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div style={{ fontWeight: '600', fontSize: '13px', color: '#333', marginBottom: '2px' }}>
                                                    {n.titulo}
                                                </div>
                                                <div style={{
                                                    color: '#777',
                                                    fontSize: '12px',
                                                    marginBottom: '4px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}>
                                                    {n.cuerpo}
                                                </div>
                                                <div style={{ color: '#bbb', fontSize: '11px' }}>
                                                    {formatFechaHora(n.fecha_hora)}
                                                </div>
                                            </div>
                                            <span
                                                title="Marcar como leída"
                                                style={{ color: '#ccc', fontSize: '15px', flexShrink: 0, paddingTop: '2px' }}
                                                onClick={function(e) { self.markAsRead(n.id, e); }}
                                            >
                                                <i className="ft-check"></i>
                                            </span>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                )}
            </li>
        );
    }
}

export default NotificationBell;
